export default "__VITE_ASSET__CVecxU9y__"